import { connect } from 'react-redux';
import { UnicodeEntity } from '@mews/enums';
import { ApplicationState } from '@mews-commander/types';
import { getResource, getResourceName } from '../../../selectors/resources';

const ParentName = ({ name }: { name: string }) => <span>{name || UnicodeEntity.Dash}</span>;

export default connect((state: ApplicationState, { id }: { id: string }) => {
    // @ts-expect-error
    const { parentResourceBuilderId } = getResource(state, { id });
    const name = parentResourceBuilderId && getResourceName(state, { id: parentResourceBuilderId });

    return {
        name,
    };
})(ParentName);
